<style lang="scss" scoped>
.fake-input {
  pointer-events: none;
  border: solid 1px lightgrey;
  border-right: 0;
  text-indent: 5px;
  max-width: 185px;
}
</style>
<template>
  <!-- eslint-disable max-len -->
  <div class="container">
    <div class="theme-color-wrapper p-2 booking-slots-page" v-if="!loading">
      <div class="calls row">
        <section class="col-12">
          <h2 cy="page-title" class="font-weight-boldererer mb-2">Update Booking Slot</h2>
          <router-link :to="{ name: 'booking-slots'}" class="body-text">
            &laquo; Back to booking slots
          </router-link>
        </section>
      </div>

      <div class="row my-2">
        <div class="slot-stage-wrapper">
          <div class="col-12">
            <section class="slot-stage">
              <h4 class="pb-1">When should the slot start?</h4>
              <p>Slots are up to {{ max_slot_length }} minutes long. Calls are terminated when the slot ends</p>

              <div class="clock-custom d-flex" style="font-size: 18pt" cy="start-time">
                <div>
                  <i @click="increaseTimeSlot('slotBeginHour', hours, updateEndSlot)"
                     class="fas fa-chevron-up d-block"></i>
                  <span class="d-block">{{ slotBeginHour }} :</span>
                  <i @click="decreaseTimeSlot('slotBeginHour', hours, updateEndSlot)"
                     class="fas fa-chevron-down d-block"></i>
                </div>

                <div class="ml-1">
                  <i @click="increaseTimeSlot('slotBeginMin', mins, updateEndSlot)"
                     class="fas fa-chevron-up d-block"></i>
                  <span class="d-block">{{ slotBeginMin }}</span>
                  <i @click="decreaseTimeSlot('slotBeginMin', mins, updateEndSlot)"
                     class="fas fa-chevron-down d-block"></i>
                </div>
              </div>

              <p class="pb-2 mt-2 font-weight-bolder">
                This slot will start at: <b>{{ slotBeginHour }}:{{ slotBeginMin }}</b>
                <span class="px-1 d-inline-block"
                      v-if="limitedSlot">and end at: <b>{{ slotEndHour }}:{{ slotEndMin }}</b></span>
              </p>
            </section>

            <section class="slot-stage" v-if="!limitedSlot">
              <h4 class="pb-2">When should the slot end?</h4>

              <b-alert v-if="!endDateValid" show variant="danger" class="font-weight-bolder p-2">
                <i class="fas fa-exclamation-triangle mr-2"></i>Please ensure the end time is after the start time and within the {{ max_slot_length }} minute duration.
              </b-alert>

              <div class="clock-custom d-flex" style="font-size: 18pt" cy="end-time">
                <div>
                  <i @click="increaseTimeSlot('slotEndHour', hours, checkEndSlotValid)"
                     class="fas fa-chevron-up d-block"></i>
                  <span class="d-block">{{ slotEndHour }} :</span>
                  <i @click="decreaseTimeSlot('slotEndHour', hours, checkEndSlotValid)"
                     class="fas fa-chevron-down d-block"></i>
                </div>

                <div class="ml-1">
                  <i @click="increaseTimeSlot('slotEndMin', mins, checkEndSlotValid)"
                     class="fas fa-chevron-up d-block"></i>
                  <span class="d-block">{{ slotEndMin }}</span>
                  <i @click="decreaseTimeSlot('slotEndMin', mins, checkEndSlotValid)"
                     class="fas fa-chevron-down d-block"></i>
                </div>
              </div>

              <p class="pb-2 mt-2 font-weight-bolder" cy="slot-text">
                This slot will start at: <b>{{ slotBeginHour }}:{{ slotBeginMin }}</b>
                <span class="px-1 d-inline-block">and end at: <b>{{ slotEndHour }}:{{ slotEndMin }}</b></span>
              </p>
            </section>

            <section class="slot-stage">
              <h4 class="pb-2 font-weight-bolder">Add a slot description</h4>

              <!--            <div class="form-group full-width d-flex">-->
              <!--              <input class="fake-input" v-model="bookingSlotName" type="text">-->
              <!--              <input-->
              <!--                style="border-left: 0"-->
              <!--                class="form-control"-->
              <!--                type="text"-->
              <!--                placeholder="Slot description"-->
              <!--                v-model="bookingSlotDescription"-->
              <!--              >-->
              <!--            </div> -->

              <div class="form-group full-width d-flex">
                <input cy="slot-name"
                  style="border-left: 0"
                  class="form-control"
                  type="text"
                  placeholder="Slot description"
                  v-model="bookingSlotName"
                >
              </div>
            </section>

            <section class="slot-stage">
              <h4 class="pb-2 pt-2">Do you want to apply a date range?</h4>

              <b-form-checkbox @change="resetStartEndDate()" v-model="applyDateRange" name="check-button" switch>
                Apply date range
              </b-form-checkbox>

              <section v-if="applyDateRange">
                <p class="pt-3">Select a start and end date</p>
                <div>
                  <label>Start Date</label>
                  <b-form-datepicker
                    v-model="start_date"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    @input="end_date = ''"
                  />
                  <label>End Date</label>
                  <b-form-datepicker
                    v-model="end_date"
                    :min="start_date"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                  />
                </div>
              </section>

            </section>

            <section class="slot-stage">
              <button :class="{'disabled': !endDateValid}" @click="displayBookingSlotInfoModal()"
                      class="btn btn-block btn-success mt-2">
                Change booking slot (This will make the slot available for bookings)
              </button>
            </section>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <p>Loading...</p>
    </div>
  </div>
  <!-- eslint-enable -->
</template>

<script>
import moment from 'moment';
import BookingSlotService from '@/services/BookingSlotService';
import {ERROR_CODES} from '../../util/errorCodes';
import {mapState} from 'vuex';

export default {
  name: 'update-booking-slot',
  computed: mapState({
    prison: state => state.prison.prison,
    limitedSlot: state => state.prison.prison ? state.prison.prison.limitedSlot : '',
    max_slot_length: state => state.prison.prison ? state.prison.prison.max_slot_length : '',
    allBookingSlots: state => state.bookingSlots.bookingSlots,
  }),
  watch: {
    limitedSlot() {
      this.updateEndSlot();
    }
  },
  data() {
    return {
      bookingSlotId: '',
      loading: true,
      // bookingSlotDescription: '',
      bookingSlot: null,
      bookingSlotActive: null,
      bookingSlotName: '',
      slotBeginHour: '',
      slotBeginMin: '',
      slotEndHour: '',
      slotEndMin: '',
      start_date: '',
      end_date: '',
      weekDays: BookingSlotService.getWeekdays(),
      hours: BookingSlotService.getHours(),
      mins: BookingSlotService.getMinutes(),
      endDateValid: true,
      applyDateRange: false,
    };
  },
  async mounted() {
    await this.$store.dispatch('prison/getPrison');
    this.bookingSlotId = this.$route.params.bookingSlotId;
    this.getBookingSlot();
    await this.$store.dispatch('bookingSlots/getBookingSlots');
  },
  methods: {
    getBookingSlot() {
      BookingSlotService.getBookingSlotSingle(this.bookingSlotId).then(res => {
        this.bookingSlot = res.data;
        //  const name = this.bookingSlot.name.split('|');

        // this.bookingSlotName = name[1] ? name[0] + '|' : name[0];
        // console.log(name, 'slot', this.bookingSlot.name);
        // if(name[1]){
        //   this.bookingSlotDescription = name[1];
        // }

        this.bookingSlotName = this.bookingSlot.name;
        this.bookingSlotActive = this.bookingSlot.active ? 'active' : 'inActive';
        this.slotBeginHour = this.bookingSlot.slot_begin.split(':')[0];
        this.slotBeginMin = this.bookingSlot.slot_begin.split(':')[1];
        this.slotEndHour = this.bookingSlot.slot_end.split(':')[0];
        this.slotEndMin = this.bookingSlot.slot_end.split(':')[1];
        this.start_date = this.bookingSlot.start_date ? moment(this.bookingSlot.start_date).format('YYYY-MM-DD') : '';
        this.end_date = this.bookingSlot.end_date ? moment(this.bookingSlot.end_date).format('YYYY-MM-DD') : '';

        if (this.start_date) {
          this.applyDateRange = true;
        }

        this.loading = false;
      }).catch(err => {
        console.log('Error getting booking slot ', err);
        this.$toast.error('Error getting the booking slot', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
        this.$router.go(-1);
      });
    },
    validUpdate() {
      return this.bookingSlotName && this.bookingSlotName.length > 0;
    },
    displayBookingSlotInfoModal() {
      this.$swal({
        title: 'Existing bookings will not be changed',
        text: 'This change is only valid for new bookings. Existing bookings must be honoured in their original time.',
        icon: 'info',
        buttons: true,
      }).then((value) => {
        if (value) {
          this.checkDuplicateBookingSlots();
        }
      });
    },
    checkDuplicateBookingSlots() {
      let duplicateSlots = [];

      // Loop through selected days to get duplicated slots and create new ones
      let slotBegin = `${this.slotBeginHour}:${this.slotBeginMin}`;
      let slotEnd = `${this.slotEndHour}:${this.slotEndMin}`;

      duplicateSlots = BookingSlotService.getDuplicatedDates(this.allBookingSlots, this.bookingSlot.day_of_week, slotBegin, slotEnd, this.bookingSlot._id);
      duplicateSlots = BookingSlotService.filterDuplicatesByDateRange(duplicateSlots, {
        start_date: this.start_date,
        end_date: this.end_date
      });
      if (duplicateSlots[0]) { // warn if duplicates, otherwise create
        this.displayBookingSlotOverlapModal(duplicateSlots[0], duplicateSlots);
      } else {
        this.updateBookingSlot();
      }
    },
    displayBookingSlotOverlapModal(slot, slots) {
      const name = BookingSlotService.getOverlapName(slot);

      this.$swal({
        title: `This overlaps with an existing slot ${name}`,
        text: 'Do you want to overwrite the existing slot?',
        icon: 'warning',
        buttons: true,
      }).then((value) => {
        if (value) { // if yes update slot
          // delete overlap
          let slotClone = Object.assign({}, slot);
          slotClone.active = false;
          BookingSlotService.updateBookingSlot(slotClone._id, slotClone).then(() => {
            this.manageUpdatingSlots(slot, slots);
          }).catch(err => {
            console.log('Error deleting booking slot ', err);
            // eslint-disable-next-line max-len
            if (err && err.response && err.response.data && err.response.data.error === ERROR_CODES.BOOKING_SLOTS.OVERLAP) {
              this.$toast.error('Error deleting the booking slot, booking slot overlaps', {
                toastClassName: ['toast-std', 'warning-toast'],
              });
            } else {
              this.$toast.error('Error deleting the booking slot', {
                toastClassName: ['toast-std', 'warning-toast'],
              });
            }
          });
        } else {
          this.$toast.info('Booking slot not updated');
          this.$router.push('/booking-slots');
        }
      });
    },
    manageUpdatingSlots(slot, slots) {
      let newSlots = slots.splice(1); // remove the first slot

      if (newSlots[0]) {
        this.displayBookingSlotOverlapModal(newSlots[0], newSlots);
      } else { // finished update all slots
        this.updateBookingSlot();
      }
    },
    updateBookingSlot() {
      if (this.validUpdate()) {
        this.$toast.info('Updating booking slot...');

        const updateDto = {
          // name: this.bookingSlotDescription ? this.bookingSlotName + '-' + this.bookingSlotDescription : this.bookingSlotName,
          name: this.bookingSlotName,
          active: this.bookingSlotActive === 'active',
          slot_begin: `${this.slotBeginHour}:${this.slotBeginMin}`,
          slot_end: `${this.slotEndHour}:${this.slotEndMin}`,
          start_date: this.start_date,
          end_date: this.end_date,
        };

        BookingSlotService.updateBookingSlot(this.bookingSlotId, updateDto).then(() => {
          this.$toast.success('Booking slot successfully updated', {
            toastClassName: ['toast-std', 'success-toast'],
          });
          this.$router.push('/booking-slots');
        }).catch(err => {
          console.log('Error updating booking slot ', err.response);
          // eslint-disable-next-line max-len
          if (err && err.response && err.response.data && err.response.data.error === ERROR_CODES.BOOKING_SLOTS.OVERLAP) {
            //this.displayBookingSlotOverlapModal();
            console.log('overlap');
          } else {
            this.$toast.error('Error updating the booking slot', {
              toastClassName: ['toast-std', 'warning-toast'],
            });
          }
        });
      } else {
        this.$toast.info('Please check you have entered a name for the booking slot');
      }
    },
    updateEndSlot() {
      if (this.limitedSlot) { // limited slot, always add 30 mins
        let time = this.slotBeginHour + ':' + this.slotBeginMin + ':00';
        let addMinutes = moment(time, 'HH:mm:ss').add(this.max_slot_length, 'minutes').format('HH:mm');
        let split = addMinutes.split(':');

        this.slotEndHour = split[0];
        this.slotEndMin = split[1];
      } else {
        this.checkEndSlotValid();
      }
    },
    checkEndSlotValid() {
      let startTime = this.slotBeginHour + ':' + this.slotBeginMin + ':00';
      let endTime = this.slotEndHour + ':' + this.slotEndMin + ':00';

      startTime = moment(startTime, 'HH:mm:ss');
      endTime = moment(endTime, 'HH:mm:ss');

      let duration = moment.duration(endTime.diff(startTime));
      let minutesLeft = duration.asMinutes();

      let negative = Math.sign(minutesLeft) === -1;

      this.endDateValid = !negative && (minutesLeft <= this.max_slot_length);
    },
    increaseTimeSlot(prop, array, callback) {
      let value = this[prop];
      let max = array.length - 1;
      let index = array.indexOf(value);

      if (index < max) {
        this[prop] = array[index + 1]; // first element
      } else {
        this[prop] = array[0];
      }

      if (callback) {
        callback();
      }
    },
    decreaseTimeSlot(prop, array, callback) {
      let value = this[prop];
      let max = array.length - 1;
      let index = array.indexOf(value);

      if (index === 0) {
        this[prop] = array[max]; // first element
      } else {
        this[prop] = array[index - 1];
      }

      if (callback) {
        callback();
      }
    },
    resetStartEndDate() {
      this.start_date = '';
      this.end_date = '';
    }
  },
};
</script>
